import React, {Component} from 'react'
import {Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import styles from './Button.css'
import {faAngleLeft} from "@fortawesome/pro-light-svg-icons/index";

export default class Button extends Component {
    render() {

        const {pullRight, href, goBack, history, onClick, submit, center, light, inline, anchor} = this.props;

        let classes = [styles.button];

        if(pullRight) {
            classes.push(styles.pullRight);
        }

        if(center) {
            classes.push(styles.center);
        }

        if(inline) {
            classes.push(styles.inline);
        }

        if(light) {
            classes.push(styles.light);
        }

        if(anchor) {
            return (
                <a
                    href={href}
                    className={[classes.join(' ')]}
                >
                    {this.props.children}
                </a>
            )
        }

        if(submit) {
            return (
                <button type="submit" className={classes.join(' ')}>{this.props.children}</button>
            )
        }

        if(goBack) {
            classes.push(styles.goBack);

            return (
                <a href="#" onClick={() => history.goBack()} className={[classes.join(' ')]}>
                    <FontAwesomeIcon icon={faAngleLeft} size="3x" /> {this.props.children}
                </a>
            )
        }

        if(onClick) {
            return (
                <Link
                    to={href}
                    className={[classes.join(' ')]}
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                >
                    {this.props.children}
                </Link>
            )
        }

        return (
            <Link
                to={href}
                className={[classes.join(' ')]}
                onClick={onClick}
            >
                {this.props.children}
            </Link>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js